import Style from "../../../utility/Style";
import { Sheet } from "../GridView";

interface Props
{
    sheet: Sheet
}

export default function ConditionalFormattingStyles({ sheet }: Props)
{
    return <>{Object.entries(sheet.conditionalFormatting ?? {}).map(([id, ruleDef]) =>
        <Style key={id} name={id} style={ruleDef.formatStyle} />)}</>
}